import { Component, ElementRef, ViewChild, HostListener  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { LocationStrategy, Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent {
  uploadshow : boolean = true;
  validationCheck  : boolean = false;
  closeResult: string = '';
  uploadedFilesData :any = {};
  fileFormatError : boolean = false;
  moreFileFormatError : boolean = false;
  designPackageName :any;
  currentDateTime:any;
  fileReuploadedClicked:boolean = false;
  reUploadedFile:boolean=false;
  
  
  @ViewChild("designFName") fileName!: ElementRef ;
  @ViewChild("partNum") partNumer!: ElementRef ;
  @ViewChild("partRevision") partRevision! : ElementRef ;
  constructor(
    private router: Router,
    private activatedRoute : ActivatedRoute,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private modalService: NgbModal,
    private locationStg: LocationStrategy,
    private location: Location,
    private cookieSer : CookieService
    ){
    }

    ngOnInit(): void {
      this.restrictBrowserButtons();
      localStorage.setItem('apiSerDataObj','')
      localStorage.setItem('commonDataObj','')
      localStorage.setItem('apDtId','')
      this.commonService.commonMainObj.invalidUser = false;
      window.scrollTo(0, 0);
      history.pushState(null, '');
      this.fileReuploadedClicked = false;
      if(this.commonService.commonMainObj.fromWhereReupload == "otherPageReUpload"){ 
      }else{
        this.commonService.validationLoadingShow();
        this.activatedRoute.queryParams.subscribe(params => {
          this.commonService.commonMainObj.fileId = params['fileId'];
        });
        if(this.commonService.commonMainObj.fileId){
          setTimeout(()=>{
            this.getUploadedData();
          },5000);
        }else{
          this.commonService.goBack();
        }
        window.scrollTo(0, 0);
      }
    }
    restrictBrowserButtons(){
      this.commonService.commonMainObj.openCheck = false;
      history.pushState({}, '', window.location.href);
      this.locationStg.onPopState(() => {
        history.pushState({}, '', window.location.href);
        if(!this.commonService.commonMainObj.openCheck){
          this.restrictBrowserButtonsAlert();
        }
      });
    }
    restrictBrowserButtonsAlert(){
      this.commonService.commonMainObj.openCheck = true;
      Swal.fire({
        title: 'Alert!',
        text:"Navigating back will result in the loss of data",
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.commonService.goBack();
        } else if (result.isDismissed) {
          this.commonService.commonMainObj.openCheck = false;
        }
      })
    }
    @HostListener('window:popstate', ['$event'])
    onPopState(event:any) {
      console.log('Back button pressed');
      event.preventDefault();
      this.restrictBrowserButtons();
    }
    
    getUploadedData(){
      this.fileFormatError = false;
      $(".progress-bar").width('60%');
      if(this.moreFileFormatError){
        this.commonService.commonMainObj.uploadedFilesData= '';
      }
      this.moreFileFormatError = false;
      this.apiService.fileDataWithId().subscribe((data:any)=>{
        // console.log("FileData", data);
        this.commonService.commonMainObj.listOfAllFiles = [];
        this.commonService.commonMainObj.fabErrWarArray=[];
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          if(data.error){
            this.commonService.alertCall('Error!!',data.description);
            //this.uploadshow = true;
            this.commonService.goBack();
          }else{
            //console.log("fileUploadedData",data);
            var dupObj = JSON.stringify(data);
            this.apiService.apiMainObj.fileUploadedData = JSON.parse(dupObj);
            this.commonService.commonMainObj.fileUploadedData = JSON.parse(dupObj);
            this.commonService.commonMainObj.bomFileIncluded = data.assemblyErrors && data.assemblyErrors.FV_BM_E01?true:false;
            this.commonService.commonMainObj.uploadedFileName = data.filename;
            this.commonService.commonMainObj.s3FileName = data.s3_file;
            this.commonService.commonMainObj.source = data.source;
            this.commonService.commonMainObj.odbFilesAvailable = data.directoryList && data.directoryList.length>0?data.directoryList[0].type == 'ODB' ? 'Yes' : 'No':'';
            this.commonService.commonMainObj.gerbersProvided = data.directoryList && data.directoryList.length>0?data.directoryList[0].type == 'GERBER' ? 'Yes' : 'No':'';
            var errorFound = false;
            this.commonService.loadingHide();
            data['fileErrors'] = [];
            if(Object.keys(data.fabErrors).length > 0){
              for(var errIndx in data.fabErrors){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabErrors[errIndx])
                if(errIndx != 'FV_GE_E00'){
                  data['fileErrors'].push(data.fabErrors[errIndx]);
                }
                if(errIndx == 'FV_GE_E00'){
                  // this.fileFormatError = true;
                  // this.moreFileFormatError = true;
                  Swal.fire({
                    title: "Warning!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if(result.isConfirmed) {
                      //$("#checkFileUpload").trigger('click');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_GE_E01'){
                  this.fileFormatError = true;
                  this.moreFileFormatError = true;
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['description'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Re-Upload Files',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                        $("#checkFileUpload").trigger('click');
                        $("#checkFileUpload").val('');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_GE_E02'){
                  let message= '';
                  errorFound = true;
                  this.moreFileFormatError = true;
                  if(data.fabErrors[errIndx]['error'].split('|').length>1){
                    data.fabErrors[errIndx]['error'] = data.fabErrors[errIndx]['error'].split('|')
                    for(let sdjfs in data.fabErrors[errIndx]['error']){
                      if(sdjfs == "0"){
                        message = message+'<li style="list-style-type:none;">'+data.fabErrors[errIndx]['error'][sdjfs]+'</li>'
                      }else{
                        message = message+'<li>'+data.fabErrors[errIndx]['error'][sdjfs]+'</li>'
                      }
                    }
                    message = '<ul style="text-align: start;">'+message+'</ul>';
                  }else{
                    message = '<div>'+data.fabErrors[errIndx]['error']+'</div>';
                  }
                  // this.commonService.confirmAlert('Error!!',data.fabErrors[errIndx]['error'],'Re-Upload Files','Cancel')
                  // text:data.fabErrors[errIndx]['error'],
                  Swal.fire({
                    title: "Error!!",
                    html:message,
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Re-Upload Files',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                        $("#checkFileUpload").trigger('click');
                        $("#checkFileUpload").val('');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_SE_E03'){
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                      this.commonService.goBack();
                    } else if (result.isDismissed) {
                      // this.commonService.goBack();
                    }
                  })
                }
              }
            }
            if(data.fabWarnings && Object.keys(data.fabWarnings).length > 0){
              data['fileWarnings'] = [];
              for(var errIndx in data.fabWarnings){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabWarnings[errIndx])
                if(!errorFound && errIndx != 'FV_GE_E00'){
                  data['fileWarnings'].push(data.fabWarnings[errIndx]);
                }
                if(!errorFound && errIndx == 'FV_GE_E00'){
                  // this.commonService.confirmAlert('Warning!!',data.fabWarnings[errIndx]['warning'],'Ok','Cancel')
                  Swal.fire({
                    title: "Warning!!",
                    text:data.fabWarnings[errIndx]['warning'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if(result.isConfirmed) {
                      //$("#checkFileUpload").trigger('click');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }
                this.commonService.commonMainObj.boardOutlineProvided = data.fabWarnings.FV_BO_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.layerOrderProvided = data.fabWarnings.FV_CL_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.drillFileProvided = data.fabWarnings.FV_DR_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.fabDrawingProvided = data.fabWarnings.FV_FD_W00 ? 'No' : 'Yes';

              }
            }
            if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM || Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM).length == 0){
              this.commonService.commonMainObj.fileUploadedData.uploadedBOM = '';
            }
            this.validationCheck = false;
            this.commonService.commonMainObj.uploadedFilesData = data;
            this.designPackageName = this.commonService.commonMainObj.uploadedFilesData.filename ? this.commonService.commonMainObj.uploadedFilesData.filename.split('.').slice(0, -1).join('.'):'';
            if(data.directoryList){
              for(let i=0; i < data.directoryList.length; i++){
                for(let k=0; k < data.directoryList[i].files.length; k++){
                  data.directoryList[i].files[k]['mainFileType'] = data.directoryList[i].type;
                  this.commonService.commonMainObj.listOfAllFiles.push(data.directoryList[i].files[k]);
                }
              }
            }
          }
          $('html, body').animate({scrollTop:$('#scrollTop').position().top}, '');
        },300)
      },error =>{
        this.commonService.loadingHide();
        console.log('Error in getting file data', error);
      });
    }

    selectFile() {
      let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
      element.click();
    }

    proceedCheck(){
      if(!this.uploadedFilesData.partRevision || !this.uploadedFilesData.partNumber){
        this.commonService.alertCall('Alert!!','Please fill mandatory details.');
        return false;
      }
    }
    
    proceedToBoardsDetails(){
      this.commonService.sessionPortalLoad();
      if(this.designPackageName && this.commonService.commonMainObj.uploadedFileName && this.commonService.commonMainObj.uploadedFilesData.partNumber && this.commonService.commonMainObj.uploadedFilesData.partRevision){
        if(this.commonService.commonMainObj.uploadedFilesData.partRevision.indexOf(' ')>=0){
          this.commonService.showtoast('Spaces are not allowed for ‘Revision’','warning');
          return false;
        }
        if((this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length <= 10 && (this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length <= 40){
          if(this.commonService.commonMainObj.userSessionMemberId != null && this.commonService.commonMainObj.isGuestUser == false){
            this.commonService.loadingShow();
            setTimeout(()=>{
              this.commonService.sessionPortalLoad();
              this.commonService.loadingHide();
              this.apiService.checkUserSessionApi().subscribe((data: any)=>{  
                if(data.status == 1){
                  this.router.navigateByUrl('/boardDetails');
                }
              },error =>{
                console.log('Error in checking user session', error);   
              })
            },1500);
          }else{
            this.router.navigateByUrl('/boardDetails'); 
          }
        }else{
          if((this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length > 40 ){
            // this.commonService.alertCall('Warning!!',"Maximum allowed length for ‘Part Number’ is 40");
            this.commonService.showtoast('Maximum allowed length for ‘Part Number’ is 40','warning');
          }else if((this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length > 10){
            // this.commonService.alertCall('Warning!!',"Maximum allowed length for ‘Revision’ is 10");
            this.commonService.showtoast('Maximum allowed length for ‘Revision’ is 10','warning');
          }
          // $('html, body').animate({scrollTop:$('#scrollTop').position().top}, '');
        }
      }else{
        //console.log("commonService.commonMainObj.uploadedFilesData.partNumber",this.commonService.commonMainObj.uploadedFilesData.partNumber);
        if(this.designPackageName == '' || this.designPackageName == undefined){
          $('#designer-package-name').addClass('border-red');
          this.fileName.nativeElement.focus();
        }else if(this.commonService.commonMainObj.uploadedFilesData.partNumber == '' || this.commonService.commonMainObj.uploadedFilesData.partNumber == undefined){
          $('#part-number').addClass('border-red');
          this.partNumer.nativeElement.focus();
        }else if(this.commonService.commonMainObj.uploadedFilesData.partRevision == ''|| this.commonService.commonMainObj.uploadedFilesData.partRevision == undefined){
          $('#part-revision').addClass('border-red');
          this.partRevision.nativeElement.focus();
        }
        this.commonService.showtoast('Please fill mandatory details.','warning');
        // this.commonService.alertCall('Alert!!','Please fill mandatory details.');
      }
    }

    open(content:any) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    showToolTip(text:any,index:any){
      $("#infoIcon-"+index).html(text);
    }
    hideToolTip(text:any,index:any){
      $("#infoIcon-"+index).html("");
    }
    
    fileNameChange(eve:any){
      console.log("eve",eve.target.value);
      var forbiddenChars = new RegExp("\\s*[. ]");
      if(forbiddenChars.test(this.designPackageName)){
        this.designPackageName=this.designPackageName.replace(forbiddenChars,'');
      }
      this.commonService.commonMainObj.uploadedFilesData.filename = this.designPackageName+".zip"
    }
    openModal(content:any){
      var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
        modalRef.result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
}


